const pluralHandler = (number, word) => {
  return number > 1 ? word + "s" : word;
};

export default pluralHandler;
